import { CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import styled from 'styled-components';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';
import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { ANNUAL } from 'self-service-api/constants/Terms';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import SkeletonLoadWrapper from '../components/common/loading/SkeletonLoadWrapper';
import CrmSuitePrice from '../components/merch-card/price-display/CrmSuitePrice';
import { SUITE_INTERSTITIAL } from '../constants/pricing/PriceDisplayOverrides';
import { SUITE_CARD, UPGRADE_PAGE_HEADER } from '../constants/tracking/Locations';
import { hasPricingAndPurchasingSucceededSelector } from '../selectors/LoadingStateSelectors';
import MarketingProPurchaseMotions from './MarketingProPurchaseMotions';
import CrmSuiteStarterCheckoutButton from './purchase-motion-buttons/CrmSuiteStarterCheckoutButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "UpgradePageMerchCard__Container",
  componentId: "sc-1gjy9ix-0"
})(["max-width:315px;margin-top:32px;"]);
const UpgradePageMerchCard = ({
  purchaseMotions,
  upgradeData,
  upgradePointApiName,
  handlePurchaseMotionButtonClick
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  if (purchaseMotions.length === 3 && upgradePointApiName === MARKETING_HUB_PROFESSIONAL) {
    return /*#__PURE__*/_jsx(MarketingProPurchaseMotions, {
      upgradeData: upgradeData,
      purchaseMotions: purchaseMotions,
      handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
    });
  }
  return /*#__PURE__*/_jsxs(Container, {
    children: [upgradePointApiName === CRM_SUITE_STARTER_BUNDLE && /*#__PURE__*/_jsx("div", {
      className: "p-bottom-7",
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [16, 23, 16],
        widths: [60, 70, 130],
        className: "flex-column",
        Content: CrmSuitePrice,
        contentProps: {
          productLevel: STARTER,
          priceDisplayOverride: SUITE_INTERSTITIAL,
          termOverride: ANNUAL
        }
      })
    }), purchaseMotions.map((purchaseMotion, i) => /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      className: "m-x-auto m-bottom-4",
      level: i + 1,
      location: UPGRADE_PAGE,
      purchaseMotions: purchaseMotions,
      style: {
        width: '100%'
      },
      upgradeData: upgradeData,
      use: i === 0 ? 'primary' : 'secondary',
      onClick: handlePurchaseMotionButtonClick,
      trackingSource: UPGRADE_PAGE_HEADER,
      overrides: {
        // Return a pre-configured button for suite starter when purchaseMotion is buyTouchless,
        // else return nothing. Checkout button won't work for other products.
        [BUY_TOUCHLESS]: upgradePointApiName === CRM_SUITE_STARTER_BUNDLE ? () => /*#__PURE__*/_jsx(CrmSuiteStarterCheckoutButton, {
          trackingSource: SUITE_CARD,
          ctaStyles: {
            width: '100%',
            lineHeight: '23px'
          }
        }) : undefined
      }
    }, purchaseMotion))]
  });
};
export default UpgradePageMerchCard;